import React from 'react';
import { ImageFallback, ImagePlaceholder } from '@navi-toolbox/ui-components';
import { thumb, THUMB_GAP, THUMB_HEIGHT } from './styles';
import { useTranslation } from 'react-i18next';
import { useOptimisedImages } from '@navi-toolbox/hooks';

type Props = {
  src: string;
  index: number;
  onClick: (mediaType: string, imgSrc: string, index: number) => void;
};

export const DATA_QA_THUMB_ITEM_IMAGE = 'thumb-item-image';

function ThumbImage({ src, index, onClick }: Props) {
  const { t } = useTranslation();
  const { thumb: imageThumb } = useOptimisedImages({
    src,
    sizes: {
      thumb: {
        h: THUMB_HEIGHT.toString(),
        w: THUMB_HEIGHT.toString(),
      },
    },
  });

  return (
    <picture>
      <source srcSet={`${imageThumb?.xx} 2x, ${imageThumb?.x} 1x`} />
      <ImagePlaceholder
        data-qa={DATA_QA_THUMB_ITEM_IMAGE}
        className={thumb}
        src={imageThumb?.x || ''}
        data-src={imageThumb?.x || ''}
        alt={`слайд ${index}`}
        loading="lazy"
        onClick={() => onClick('mediaPdpPhoto', src, index)}
        fallback={
          <div style={{ paddingBottom: THUMB_GAP }}>
            <ImageFallback alt={t('ui.image.alt')} width={THUMB_HEIGHT} height={THUMB_HEIGHT} />
          </div>
        }
      />
    </picture>
  );
}

export { ThumbImage };
